import { render, staticRenderFns } from "./ContentFileComponet.vue?vue&type=template&id=33fa85c9&"
import script from "./ContentFileComponet.vue?vue&type=script&lang=js&"
export * from "./ContentFileComponet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports